import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-edit-nedsattning',
  templateUrl: './edit-nedsattning.component.html'
})
export class EditNedsattningComponent implements OnChanges, OnInit {
  @Input() rowdata;
  @Output() doSave = new EventEmitter();
  @Output() doClose = new EventEmitter();
  form;
  

  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      memberId: ['', ''],
      givenName: ['', ''],
      familyName: ['', ''],
      startDate: ['', ''],
      endDate: ['', ''],
      payPercentage: ['', ''],
      memberFeeId: ['', '']
    });
  }
  
  ngOnChanges(changes: SimpleChanges) {
    if (changes.rowdata.currentValue) {
      this.form.patchValue(this.rowdata);
    }
  }

  save() {
    this.doSave.emit(this.form.value);
  }

  close() {
    this.doClose.emit();
  }
}
